import React from 'react';
import { FDStack } from '@facet-wealth/design';
import Text from 'Components/ComponentLibrary/Atoms/Text';

function PlannerAssignmentStepHeader({ resource }) {
  return (
    <FDStack direction={'column'} spacing={4} alignItems={'center'}>
      <Text
        variant="h1"
        color="primary"
        weight={'medium'}
        align={'center'}
        value={resource.attr('title')}
      />
      <FDStack direction={'column'} spacing={2}>
        {
          resource.attr('subtitle').map((subtitle) => (
            <Text
              variant="h5"
              color="primaryGray"
              weight={'medium'}
              align={'center'}
              value={subtitle}
              lineHeight={'small'}
            />
          ))
        }
      </FDStack>
    </FDStack>
  );
}

export default PlannerAssignmentStepHeader;
